import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './styles.css';

const BasicInputFile = props => {
  const {
    file,
    disclaimer,
    fieldName = 'file',
    labelText = 'Select file',
    onRemoveHandler,
    onChangeHandler,
    inputStyles,
    accept,
  } = props;

  const onRemove = () => {
    if (onRemoveHandler && typeof onRemoveHandler === 'function') {
      onRemoveHandler(fieldName);
    }
  };

  return (
    <div className="basic-input-file" style={inputStyles}>
      {file ? (
        <>
          <span className="basic-input-file__name">
            <span className="basic-input-file__caption">{file.name}</span>{' '}
            <FontAwesomeIcon
              onClick={onRemove}
              icon={faTimes}
              color="#f40"
              size="lg"
              className="basic-input-file__button"
            />
          </span>
        </>
      ) : (
        <>
          <input
            type="file"
            className="basic-input-file__input"
            name={fieldName}
            id={fieldName}
            onChange={onChangeHandler}
            accept={accept}
          />{' '}
          <label htmlFor={fieldName}>{labelText}</label>
          {disclaimer && (
            <span className="basic-input-file__disclaimer">{disclaimer}</span>
          )}
        </>
      )}
    </div>
  );
};

BasicInputFile.propTypes = {
  file: PropTypes.object,
  fieldName: PropTypes.string,
  labelText: PropTypes.string,
  onRemoveHandler: PropTypes.func,
  onChangeHandler: PropTypes.func.isRequired,
};

export default BasicInputFile;
